import PermissionInfo from "@components/permissions/permissionInfo";
import { Box, MenuItem, Stack } from "@mui/material";
import { ReactElement } from "react";

interface ILockedMenuButtonProps {
  onClick?: any;
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  title: string | ReactElement;
  locked?: boolean;
  moduleLocked?: boolean;
  disabled?: boolean;
  module?: string;
  handleOpenModuleDialog?: (name: string) => void;
}

export const LockedMenuButton: React.FC<ILockedMenuButtonProps> = (props) => {
  const {
    onClick,
    startIcon,
    endIcon,
    locked,
    moduleLocked,
    title,
    disabled,
    module,
    handleOpenModuleDialog,
  } = props;

  return (
    <MenuItem
      disabled={disabled}
      onClick={(e) => {
        if (!locked) {
          onClick?.(e);
        }
        if (moduleLocked) handleOpenModuleDialog?.(module ?? "");
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        minWidth: 200,
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        {startIcon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& svg": { width: 20, height: 20 },
            }}
          >
            {startIcon}
          </Box>
        )}

        {typeof title === "string" ? (
          title
        ) : (
          <Box
            sx={{
              minWidth: 0,
            }}
          >
            {title}
          </Box>
        )}
      </Stack>
      <Box
        sx={{
          ml: "auto",
        }}
      >
        {locked ? <PermissionInfo moduleLocked={moduleLocked} /> : endIcon}
      </Box>
    </MenuItem>
  );
};
